import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface ISegmentTree {
  filterOptions: IFilterOptions;
  selectedSegments: string[];
  setSelectedSegments: (items: string[]) => void;
}

const SegmentTree = ({ filterOptions, selectedSegments, setSelectedSegments }: ISegmentTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatSegments =
    filterOptions?.segments.map((segment) => ({
      id: segment.id,
      name: segment.label,
      type: "role-management",
    })) || [];

  const filteredSegments = formatSegments.filter((segment) =>
    get(segment, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectSegment = ({ items }: SelectionChangeResponse) => setSelectedSegments(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredSegments}
      selectedItems={selectedSegments}
      onSelectionChange={handleSelectSegment}
      hasMultiselect={!isEmpty(filteredSegments)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-role-management" value={filteredSegments.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em segmento" onChange={handleUpdateSearch} />}
    />
  );
};

export default SegmentTree;
